import {ReleaseTogglesType} from "./ReleaseToggles";

export const RELEASE_TOGGLE_ALL_ON: ReleaseTogglesType = {
    enableGoalsSummaryReport: true,
    enableEstateFlowchart: true,
    enableGoogleAnalytics: true,
    enableEstateFlowchartMVPRelease: true,
    enableHandlePresenterLeaveActiveMeeting: true,
    enableGoalsGoogleAnalytics: true,
    enableAssetsGoogleAnalytics:true,
    enableAdditionalDistributionLayer: true,
    enableReportingBackendRearchitecture: true,
    enableAsyncReporting: true,
    enableDEFCollapsibleLayer: true
}
export const RELEASE_TOGGLE_ALL_OFF: ReleaseTogglesType = {
}
